<template>
  <a
    :class="myClasses"
    :style="styles"
    :href="url"
  >
    <span v-if="hasAccess && hasAccessText">{{ hasAccessText }}</span>
    <span v-else>{{ text }}</span>
  </a>
</template>

<script>
export default {
  props: ['color', 'text', 'hasAccessText', 'classes', 'hasAccessClasses'],
  computed: {
    hasAccess() {
      if (typeof hasAccessToThisCourse !== 'undefined') {
          if (hasAccessToThisCourse) {
            return true
          }
      }
      return false
    },
    styles() {
        if(this.color) {
            return `background-color: ${this.color}; border-color: ${this.color};`
        }
        return ''
    },
    myClasses() {
      if (this.hasAccess && this.hasAccessClasses) {
        return this.hasAccessClasses
      }
      return this.classes
    },
    url() {
      let destination = 'checkout'

      if (this.hasAccess) {
        destination = 'watch'
      }

      if (window.location.pathname.endsWith('/')) {
        return `${window.location.protocol}//${window.location.host}${window.location.pathname}${destination}`
      }
      return `${window.location.protocol}//${window.location.host}${window.location.pathname}/${destination}`
    },
  },
}
</script>
